import ModalCompetitorsView from "./components/ModalCompetitorsView";
import useModalCompetitorsController from "./hooks/useModalCompetitorsController";
import { MODAL_COMPETITORS_FROM_MENU } from "./constants";
import FeatureAddonUnpaidPaywall from "../../FeatureAddons/FeatureAddonUnpaidPaywall";
import { FEATURE_ADDON_KEYS } from "../../../actions/featureAddons";

const ModalCompetitors = ({
  modalOpen,
  onCloseModal,
  onCallbackSelectedItems,
  from = MODAL_COMPETITORS_FROM_MENU,
  initialPreviewLibraryID = null,
  onInitialPreviewLibraryIDConsumed = () => {},
  acceptedReferenceMediaType = null,
}) => {
  const {
    layoutProps,
    filtersProps,
    galleryProps,
    previewProps,
    editorProps,
    folderModalsProps,
  } = useModalCompetitorsController({
    modalOpen,
    onCloseModal,
    onCallbackSelectedItems,
    from,
    initialPreviewLibraryID,
    onInitialPreviewLibraryIDConsumed,
    acceptedReferenceMediaType,
  });

  return (
    <>
      <FeatureAddonUnpaidPaywall
        addonKey={FEATURE_ADDON_KEYS.COMPETITORS}
        active={modalOpen}
        onLeave={onCloseModal}
      />
      <ModalCompetitorsView
        layoutProps={layoutProps}
        filtersProps={filtersProps}
        galleryProps={galleryProps}
        previewProps={previewProps}
        editorProps={editorProps}
        folderModalsProps={folderModalsProps}
      />
    </>
  );
};

export default ModalCompetitors;
